import {checkIfTextEntryTarget} from './checkIfTextEntryTarget';

// Экранная клавиатура есть только у сенсорных устройств. На десктопе окно,
// ставшее ниже при фокусе в поле ввода, — это обычная смена размера окна
const TOUCH_DEVICE_MEDIA_QUERY = '(hover: none) and (pointer: coarse)';

/**
 * Окно стало ниже из-за экранной клавиатуры, а не из-за настоящей смены
 * размера: устройство сенсорное, фокус стоит в поле набора текста, ширина
 * прежняя, высота меньше.
 *
 * Клавиатура сжимает окно не везде — так делают Chrome и Firefox на iOS,
 * приложение с домашнего экрана iPhone и встроенные браузеры Android; в
 * Safari и в Chrome на Android окно при клавиатуре остается прежним.
 *
 * Это догадка по косвенным признакам: разделение экрана при фокусе в поле
 * ввода выглядит так же. Тот, кто по ней что-то пропускает, должен
 * перепроверить размер, когда поле потеряет фокус.
 *
 * @param {{width: number, height: number}} baseSize размер окна, с которым сравниваем
 * @returns {boolean}
 */
export const checkIfViewportShrunkByKeyboard = ({width, height}) => (
  window.matchMedia(TOUCH_DEVICE_MEDIA_QUERY).matches
  && checkIfTextEntryTarget(document.activeElement)
  && window.innerWidth === width
  && window.innerHeight < height
);
